import { css } from '@adornis/chemistry/directives/css';
import { DesignSystem } from '@adornis/chemistry/elements/theming/design';
import '@adornis/digitale-helden-shared/features/animations/client/animation-live.js';
import { stateful } from '@adornis/functional-lit/stateful';
import { html, type TemplateResult } from 'lit';

export const PublishmentStatusBadge = stateful(({ published }: { published: boolean }): TemplateResult => {
  const design = DesignSystem.currentTheme.getValue();

  return html`
    <d-flex
      ${css({
        position: 'absolute',
        right: '-4px',
        top: '-4px',
        width: '14px',
        height: '14px',
        borderRadius: '50%',
        border: `2px solid ${published ? design.colors.accent : design.colors.tone.neutralAlabster}`,
        background: published ? design.colors.accent.shade(100) : design.colors.tone.secondaryText?.shade(100),
        boxShadow: published ? `0px 0px 8px ${design.colors.accent}` : '',
        zIndex: 10,
      })}
    ></d-flex>
  `;
});
